import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

export const AddEditButton = styled(Button)({
  // height: "35px",
  // fontSize: "1em",
  textTransform: "none",
  borderRadius: 0,
  padding: 0,
});
